'use client'
import Link from 'next/link'
import { Button } from '@styleguide'
import { FaChevronDown } from 'react-icons/fa'
import { ExternalLinkIcon } from '@styleguide/components/ui/icons'
import { memo } from 'react'

interface NavLink {
  href: string
  id: string
  label: string
  external?: boolean
  icon?: React.ReactNode
  dataTestId?: string
}

interface NavDropdownProps {
  open: boolean
  dataTestId?: string
  toggleCallback: () => void
  links: NavLink[]
  label?: string
  id: string
}

const NavDropdown = ({
  open,
  dataTestId = '',
  toggleCallback,
  links,
  label = '',
  id,
}: NavDropdownProps): React.JSX.Element => (
  <div className="lg:ml-2 xl:ml-4 relative cursor-pointer ">
    <Button
      id={id}
      onClick={toggleCallback}
      variant="ghost"
      size="medium"
      className="leading-6!"
    >
      <div className="flex items-center">
        <div
          className="font-medium text-base leading-6!"
          data-testid={dataTestId}
        >
          {label}
        </div>
        <FaChevronDown
          className={`ml-2 mt-[2px] transition-all ${open && 'rotate-180'}`}
        />
      </div>
    </Button>

    {open ? (
      <>
        <div
          className="fixed h-screen w-screen top-14 left-0 "
          onClick={toggleCallback}
        />
        <div
          className={`absolute z-50 top-11 left-0 min-w-[270px] bg-secondary text-white rounded-xl shadow-md transition  ${
            open ? 'p-3 overflow-hidden' : 'p-0 opacity-0 overflow-visible'
          }`}
        >
          {links.map((link) => (
            <Link
              href={link.href}
              id={`nav-${link.id}`}
              key={link.id}
              className="no-underline font-medium block py-3 whitespace-nowrap text-base px-4 rounded flex items-center justify-between"
              rel={link.external ? 'noopener noreferrer nofollow' : ''}
              target={link.external ? '_blank' : ''}
            >
              <div className="flex items-center" data-testid={link.dataTestId}>
                {link.icon}
                <div className="ml-3">{link.label}</div>
              </div>
              {link.external && <ExternalLinkIcon />}
            </Link>
          ))}
        </div>
      </>
    ) : null}
  </div>
)

export default memo(NavDropdown)
